import { Config } from "./constant";
import {
  AgentCareStore,
  ClearTypingTimestamp,
  AddMessageToStore,
  UnsetCustomer,
  SetSessionIsNotActive,
  SetSessionIsActive,
  SetHasPendingMessage,
  SetHasNoPendingMessage,
  SetChatRoomId,
  UnsetChatRoomId,
  ResetMessageStore,
  UpdateCaptchaResponse,
  GetFirstMessage,
  ResetInitRoom,
  IsSessionTimeout,
  SetTypingTimestamp,
  IsAllowCreateSession,
  DisableCreateSession,
  IsSessionActive,
  SaveAssignedAgent,
  ResetAssignedAgent,
  IncrementSessionTimeoutCount,
  IsMaxTimeoutCountReached,
  ResetSessionTimeoutCount,
  CommonStore,
  LocalStorage,
  SetCustomer,
  GetCustomer,
  LoadHistoryAfterLoad,
  MarkHistoryAsLoaded,
  GetIdPel,
  GetActiveEntryPointId,
  GetNextHistory,
  SetNextHistory,
  GetHistoryHasNext,
  SetHistoryHasNext,
  UpsertPendingMessage,
  DeletePendingMessage,
  ReplacePendingMessage,
  SetNetworkStatus,
  ResetPendingMessage
} from "./Store";
import {
  ConnectionInitiated,
  AgentRepliesText,
  ChatRoomInitiated,
  MessageCreated,
  SystemClosedTheChat,
  parse,
  ValidateStaleConversationIdResult,
  MessageWithMediaCreated,
  AgentRepliesMedia,
  SendMediaError,
  CaptchaChallengeAnswerError,
  AgentIsAssignedToChat,
  CustomerSeemsInactive,
  CustomerClosesTheChatDueToInactivity,
  FailedToInitiateChatRoom,
  PingFromServer,
} from "./model/Incoming";
import {
  AgentMessageAck,
  CustomerSendsMediaType,
  CustomerSendsText,
  CustomerSendsTextType,
  DrainBacklogMessage,
  ValidateStaleConversationId,
} from "./model/Outgoing";

import { v4 } from "uuid";
import { observable, toJS } from "mobx";
import { LogAgentRequest } from "./apis/LogAgentRequest";
import { LogActivityError } from "./apis/LogActivityError";

let message = [];
let messageBacklog = [];
let isConnectionOpen = false;
/**
 * @type {WebSocket | null}
 */
let socketRef = null;

let sessionId = null;
let timeoutIdForInit = null;
let backlogCursor = new Date().getTime()

export function resetSession() {
  clearInterval(sessionId);
  ClearTypingTimestamp();
  ResetAssignedAgent();
  UnsetCustomer();
  ResetMessageStore();
  ResetPendingMessage();
}



function startSession() {
  console.log("Begin checking!");
}

function main() {
  const checkPendingMessage = () => {
    console.log('Checking pending message..')
    const pendingMessageList = toJS(CommonStore.pendingMessage)
    const now = new Date().getTime()
    const updateList = pendingMessageList.map(item => {
      
      const { timestamp, error } = item
      const delta = now - timestamp
      
      if(delta > 10000 && !error) {
        item.error = true
        console.log('Message is error!', item, delta)
        LogActivityError(`Failed to send incoming message: ${item}`)
      }
      return item
    })
    ReplacePendingMessage(updateList)
    setTimeout(() => checkPendingMessage(), 30000)
  }

  const checkIsOnline = async() => {
    try {
      const now = new Date().getTime()
      const delta = now - backlogCursor
      console.log('Checking online status', delta, socketRef)
      const deltaInMult = delta / 5000
      if(deltaInMult > 1 && isConnectionOpen) {
        console.log('Connection is unstable!')
        SetNetworkStatus(false)
        closeConnection('Connection is unstable!')
        LogActivityError(`Encountered unstable connection! Ws state: ${socketRef.readyState}`)
      }
    } catch(e) {
      
    }
    setTimeout(() => checkIsOnline(), 3000)
  }

  setTimeout(() => {
    checkPendingMessage()
    checkIsOnline()
  }, 3000)
}



export function StartTimerForTimeout(triggerAt) {
  console.log("Check init timeout!");
  const isAllow = IsAllowCreateSession();
  const isSessionActive = IsSessionActive();
  if (isAllow && !isSessionActive) {
    let repeat = false;
    if (triggerAt) {
      const delta = new Date().getTime() - triggerAt;
      if (delta < 60000) {
        repeat = true;
      } else {
        DisableCreateSession(
          "Agent seems to be busy. Please wait a bit longer"
        );
        ResetInitRoom();
        LogActivityError("Failed to start conversation with agent!")
      }
    } else {
      repeat = true;
    }
    console.log("Will repeat check..");
    if (repeat) {
      timeoutIdForInit = setTimeout(
        () =>
          StartTimerForTimeout(triggerAt ? triggerAt : new Date().getTime()),
        1000
      );
    }
  } else {
  }
}

async function initConnection(onMessage, onOpen, onClose) {
  console.log('Init connection!')
  let Resolver;
  let Rejecter;
  let hasFiredOpen = false
  let hsaFiredClose = false
  const promise = new Promise((resolve, reject) => {
    Resolver = resolve;
    Rejecter = reject;
  });
  const socket = new WebSocket(Config.websocketUrl);
  socket.addEventListener("open", (e) => {
    if(hasFiredOpen) return
    hasFiredOpen = true
    onOpen(socket);
    Resolver();
  });
  socket.addEventListener("close", (e) => {
    if(hsaFiredClose) return
    hsaFiredClose = true
    isConnectionOpen = false;
    closeConnection()
    onClose();
  });

  socket.addEventListener("message", (newMessage) => {
    Resolver();
    onMessage(newMessage);
  });
  
  return promise.then(() => socket);
}

export function getConnectionId() {
  return LocalStorage.get("connectionId");
}

export function getChatRoomId() {
  return LocalStorage.get("chatRoomId");
}

export function unsetChatRoomId() {
  UnsetChatRoomId();
  LocalStorage.remove("chatRoomId");
}

export function checkIsConnectionOpen() {
  return isConnectionOpen;
}

function startSocketCore() {
  if(socketRef && isConnectionOpen) return
  initConnection(
    (newMessage) => {
      let messageFromJs = JSON.parse(newMessage.data);
      const parsed = parse(messageFromJs);
      const { type, serverSideId } = parsed;

      if(serverSideId) {
        sendWithSession(AgentMessageAck(serverSideId))
      }

      if (type == PingFromServer) {
        backlogCursor = parsed.ts
      } else if (type === ConnectionInitiated) {
        isConnectionOpen = true;
        backlogCursor = new Date().getTime()
        SetNetworkStatus(true)
        console.log("Initiated!");
        LocalStorage.set("connectionId", messageFromJs.connectionId);
        const chatRoomId = getChatRoomId();
        if (chatRoomId) {
          SetTypingTimestamp();
          sendWithSession(ValidateStaleConversationId(getChatRoomId()));
        }
      } else if (type === MessageCreated) {
        let messageFromCustomer = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
        };
        message.push(messageFromCustomer);
        SetHasNoPendingMessage();
        DeletePendingMessage(parsed.clientSideId)
        AddMessageToStore(messageFromCustomer);
      } else if (type === AgentRepliesText) {
        let messageFromAgent = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          agentName: parsed.agentName,
        };
        message.push(messageFromAgent);
        AddMessageToStore(messageFromAgent);
        
      } else if (type === ChatRoomInitiated) {
        if (IsAllowCreateSession()) {
          MarkHistoryAsLoaded();
          clearTimeout(timeoutIdForInit);
          ResetInitRoom();
          const chatRoomId = parsed.chatRoomId;

          SetCustomer(parsed.customer);
          SetSessionIsActive();
          SetChatRoomId(chatRoomId);
          startSession();
          const firstMessage = GetFirstMessage();
          if (firstMessage) {
            sendWithSession(CustomerSendsText(firstMessage));
            SetTypingTimestamp();
          }
          LogAgentRequest(parsed.customer, firstMessage);
        } else {
          console.log("Reincarnated message detected!", parsed);
        }
      } else if (type === ValidateStaleConversationIdResult) {
        if (!(parsed.isValid && parsed.conversationId == getChatRoomId())) {
          unsetChatRoomId();
          SetSessionIsNotActive();
          resetSession();
        } else {
          console.log("Is active!");
          SetSessionIsActive();
          SetChatRoomId(parsed.conversationId);
          SaveAssignedAgent(parsed.assignedAgent);
          SetCustomer(parsed.customer);
          LoadHistoryAfterLoad();
          if (!sessionId) startSession();
        }
      } else if (type === SystemClosedTheChat) {
        unsetChatRoomId();

        // SetSessionIsNotActive()
        resetSession();
      } else if (type == MessageWithMediaCreated) {
        let messageFromCustomer = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          mediaList: parsed.mediaList,
        };
        message.push(messageFromCustomer);
        DeletePendingMessage(parsed.clientSideId)
        SetHasNoPendingMessage();
        AddMessageToStore(messageFromCustomer);
      } else if (type === AgentRepliesMedia) {
        let messageFromAgent = {
          messageId: parsed.messageId,
          text: parsed.text,
          timestamp: parsed.timestamp,
          type: parsed.type,
          agentName: parsed.agentName,
          mediaList: parsed.mediaList,
        };
        message.push(messageFromAgent);
        AddMessageToStore(messageFromAgent);
      } else if (type == SendMediaError) {
        let messageFromSystem = {
          content: parsed.content,
          type: parsed.type,
          mediaList: parsed.mediaList,
          fromSystem: true,
        };
        SetHasNoPendingMessage();
        AddMessageToStore(messageFromSystem);
      } else if (type == CaptchaChallengeAnswerError) {
        UpdateCaptchaResponse(parsed.message);
        ResetInitRoom();
      } else if (type == AgentIsAssignedToChat) {
        SaveAssignedAgent(parsed.agentName || "System");
      } else if (type == CustomerSeemsInactive) {
        const customer = GetCustomer();
        let text = parsed.text;
        if (customer) {
          text = text.replace("{customerName}", customer.name);
        }
        let messageFromAgent = {
          messageId: new Date().getTime(),
          text: text,
          isSystem: true,
        };
        AddMessageToStore(messageFromAgent);
      } else if (type == CustomerClosesTheChatDueToInactivity) {
        let messageFromAgent = {
          messageId: new Date().getTime(),
          text: parsed.text,
          isSystem: true,
        };
        AddMessageToStore(messageFromAgent);
        unsetChatRoomId();
        resetSession();
      } else if (type == FailedToInitiateChatRoom) {
        DisableCreateSession(
          parsed.reason
        );
        ResetInitRoom();
        const customer = GetCustomer();
        if (customer) {
          LogAgentRequest(customer, GetFirstMessage())
        }

      }
    },
    (socket) => {
      
      console.log("Connection is opened!");
      socketRef = socket;
      if(getChatRoomId()) {
        setTimeout(() => sendWithSession(DrainBacklogMessage(getChatRoomId(), backlogCursor)), 3000)
      }
      
    },
    () => {
      SetNetworkStatus(false)
      socketRef = null;
      console.log("Connection is closed! Waiting to reconnect..");
      SetHasNoPendingMessage()
      setTimeout(() => startSocketCore(), 300);
    }
  );
}

export let send = (data) => {
  if (isConnectionOpen && socketRef && socketRef.readyState == 1) {
    socketRef.send(data, function (err) {
      if (err) {
        console.log("Error on sending to server", err);
      }
    });
  } else {

  }
};

export const sendWithSession = (data) => {
  const payload = {
    connectionId: getConnectionId(),
    message: data
  };
  const { _type } = data;
  if (_type == CustomerSendsTextType || _type == CustomerSendsMediaType) {
    UpsertPendingMessage(data, new Date().getTime())
  } else {
    
  }
  return send(JSON.stringify(payload));
};

export const retrySendMessage = (payload) => {
  DeletePendingMessage(payload.clientSideId)
  sendWithSession(payload)
}

export function getMessage() {
  return message;
}

export let closeConnection = (reason) => {
  if (isConnectionOpen && socketRef) {
    isConnectionOpen = false
    socketRef.close(3500, reason || 'No reason specified');
  }
};
startSocketCore();
main()